import types from '../mutation-types'

const state = {
  markerList: [], // 点
  circleList: [], // 圆
  polylineList: [], // 线
  polygonList: [], // 多边形
  rectangleList: [] // 矩形
}

const getters = {
  getMarkerList: (state) => {
    return state.markerList
  },
  getCircleList: (state) => {
    return state.circleList
  },
  getPolylineList: (state) => {
    return state.polylineList
  },
  getPolygonList: (state) => {
    return state.polygonList
  },
  getRectangleList: (state) => {
    return state.rectangleList
  }
}

const actions = {
  saveMarkerList({commit, state}, markerList) {
    commit(types.MAKER_LIST, markerList)
  },
  saveCircleList({commit, state}, circleList) {
    commit(types.CIRCLE_LIST, circleList)
  },
  savePolylineList({commit, state}, polylineList) {
    commit(types.POLYLINE_LIST, polylineList)
  },
  savePolygonList({commit, state}, polygonList) {
    commit(types.POLYGON_LIST, polygonList)
  },
  saveRectangleList({commit, state}, rectangleList) {
    commit(types.RECTANGLE_LIST, rectangleList)
  }
}

const mutations = {
  [types.MAKER_LIST](state, markerList) {
    state.markerList = markerList
  },
  [types.CIRCLE_LIST](state, circleList) {
    state.circleList = circleList
  },
  [types.POLYLINE_LIST](state, polylineList) {
    state.polylineList = polylineList
  },
  [types.POLYGON_LIST](state, polygonList) {
    state.polygonList = polygonList
  },
  [types.RECTANGLE_LIST](state, rectangleList) {
    state.rectangleList = rectangleList
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/myMapTable.js